export default {
      id: "check-letter-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#check-letter",
      toString: function () {
        return this.url;
      }
    }